var author = {
    state: {
        isCollapse: false,
        isMobile: false,
        isTopSideMenu: false,
        totalKmVaule: '',
        lonAndLatData: {
            starLng: '',
            starLat: '',
            endLng: '',
            endLat: ''
        },
        productData: {
            'name': '',
            'brand': '',
            'categoryId': '',
            'status': '',
            'businessCode': '',
            'createTimeArr': []
        },
        needListData: {
            needsNo: "",
            mobile: '',
            acceptMobile: '',
            status: '',
            joinCount: '',
            scoreViewNum:'',
            terminal: '',
            realName: '',
            needsType: '',
            createTimeArr: [],
            areaIdsArr: [],
            categoryIdsArr: [],
        },
        userListdata: {
            mobile: '',
            parentMobile: '',
            terminal: '',
            parentRecom: '',
            vipLevel: '',
            regTerminal: '',
            lastTerminal: '',
            staus: '',
            regTimeArr: [],
            areaIdsArr: [],
            categoryIdsArr: [],
        },
        upgradeListData: {
            countType: 'day',
            createTimeArr: [],
        },
        orderId: '',
        appealData: {
            needsNo: "",
            realName: "",
            mobile: "",
            appealType: "",
            status: "",
            dateTime: [],
        },
        appealData: {
            needsNo: "",
            realName: "",
            mobile: "",
            appealType: "",
            status: "",
            dateTime: [],
        },
        userApplyData: {
            mobile: "",
            realName: "",
            canCategory: "",
            status: "",
            createTimeArr: [],
            pledgeMoney: "",
            areaIdsArr: [],
        },
        accountData: {
            'realName': '',
            'mobile': '',
            'createTimeArr': []
        },
    },
    getters: {
        isCollapse: state => state.isCollapse,
        isMobile: state => state.isMobile,
        isTopSideMenu: state => state.isTopSideMenu,
        menus: state => state.menus,
        totalKmVaule: state => state.totalKmVaule,
        lonAndLatData: state => state.lonAndLatData,
        productData: state => state.productData,
        needListData: state => state.needListData,
        userListdata: state => state.userListdata,
        upgradeListData: state => state.upgradeListData,
        orderId: state => state.orderId,
        appealData: state => state.appealData,
        userApplyData: state => state.userApplyData,
        accountData: state => state.accountData,
    },
    mutations: {
        // mapdrag地图距离
        SET_DISTANCE(state, distance) {
            state.totalKmVaule = distance;
        },
        // mapdrag经纬度
        SET_LONLAT(state, lonlat) {
            state.lonAndLatData = lonlat;
        },
        //侧导航是否展开
        SET_COLLAPSE(state) {
            state.isCollapse = !state.isCollapse
        },
        // 商城管理，商品管理
        SET_PRODUCT(state, params) {
            state.productData = params;
        },
        // 列表详情，需求列表
        SET_NEEDLIST(state, params) {
            state.needListData = params;
        },
        // 会员管理，会员列表
        SET_USERLISTDATA(state, params) {
            state.userListdata = params;
        },
        // 会员管理，vips升级统计
        SET_UPGRADETOTAL(state, params) {
            state.upgradeListData = params;
        },
        SET_ORDERID(state, userId) {
            state.orderId = userId;
        },
        //切换手机模式  [true|是 or false|否]
        SET_MOBILE(state, flag) {
            if (flag > 1000) {
                state.isMobile = false
                state.isCollapse = false
                state.isTopSideMenu = true;
            } else if (flag > 500) {
                state.isMobile = false
                state.isCollapse = true
                state.isTopSideMenu = true;
            } else {
                state.isMobile = true
                state.isCollapse = false
                state.isTopSideMenu = false;
            }
        },
        //是否显示顶部导航
        SET_TOP_SIDE_MENU(state) {
            state.isTopSideMenu = !state.isTopSideMenu
        },
        // 申诉列表查询条件
        SET_APPEALDATA(state, params) {
            state.appealData = params;
        },

        // 工友申请查询条件
        SET_USERAPPLYDATA(state, params) {
            state.userApplyData = params;
        },
        // 会员积分列表
        SET_ACCOUNTDATA(state, params) {
            state.accountData = params;
        },
    }
}
export default author


// WEBPACK FOOTER //
// ./src/store/modules/layout.js